import api from '../../../lib/api';
import type {
  Conversation,
  ConversationVisibility,
  CreateConversationInput,
  GetMessagesResponse,
  UpdateConversationInput,
} from '../types';

export const chatApi = {
  list: (organizationId: string, includeArchived = false) =>
    api
      .get<Conversation[]>('/chat/conversations', {
        params: { organizationId, includeArchived },
      })
      .then((res) => res.data),

  get: (id: string, organizationId: string) =>
    api
      .get<Conversation>(`/chat/conversations/${id}`, { params: { organizationId } })
      .then((res) => res.data),

  create: (input: CreateConversationInput, organizationId: string) =>
    api
      .post<Conversation>('/chat/conversations', input, { params: { organizationId } })
      .then((res) => res.data),

  update: (id: string, input: UpdateConversationInput, organizationId: string) =>
    api
      .patch<Conversation>(`/chat/conversations/${id}`, input, { params: { organizationId } })
      .then((res) => res.data),

  updateVisibility: (id: string, visibility: ConversationVisibility, organizationId: string) =>
    api
      .patch<Conversation>(
        `/chat/conversations/${id}/visibility`,
        { visibility },
        { params: { organizationId } },
      )
      .then((res) => res.data),

  archive: (id: string, organizationId: string) =>
    api
      .post<Conversation>(`/chat/conversations/${id}/archive`, undefined, {
        params: { organizationId },
      })
      .then((res) => res.data),

  getMessages: (
    id: string,
    organizationId: string,
    options: { take?: number; before?: string } = {},
  ) =>
    api
      .get<GetMessagesResponse>(`/chat/conversations/${id}/messages`, {
        params: {
          organizationId,
          ...(options.take !== undefined && { take: options.take }),
          ...(options.before !== undefined && { before: options.before }),
        },
      })
      .then((res) => res.data),
};
